const styles = theme => ({
  grid: {
    width: '100%',
    maxWidth: 774,
    flexBasis: 'unset',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    userSelect: 'none',
    flexDirection: 'column',
  },
})

export default styles
